import { render, staticRenderFns } from "./categoryAddModal.vue?vue&type=template&id=151a3649&scoped=true"
import script from "./categoryAddModal.vue?vue&type=script&lang=js"
export * from "./categoryAddModal.vue?vue&type=script&lang=js"
import style0 from "./categoryAddModal.vue?vue&type=style&index=0&id=151a3649&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151a3649",
  null
  
)

export default component.exports